import { useMemo } from 'react';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';
import { useDwlLocationUsers } from 'common/hooks/dwlLocationUsers';
import DwlContactAdder from 'components/DwlContactAdder';

const DwlContacts = ({
  classes,
  values,
  errors,
  handleBlur,
  setFieldValue,
}) => {
  const { dwlLocationUsers } = useDwlLocationUsers();

  const availableUsers = useMemo(() => {
    return dwlLocationUsers.filter((user) => !values.dwlVerificationContacts.includes(user._id));
  }, [dwlLocationUsers, values.dwlVerificationContacts])

  const handleSelectContact = (value) => {
    setFieldValue('dwlVerificationContacts', [...(values.dwlVerificationContacts || []), value]);
  }
  const handleDeleteContact = (userId) => {
    setFieldValue('dwlVerificationContacts', values.dwlVerificationContacts?.filter(uId => uId !== userId));
  }

  return (
    <Grid className={classnames(classes.flexBox, classes.fullWidth)}>
      <Grid xs={12} lg={8} container item justifyContent="space-between" alignItems="center">
        <Typography variant="h4" color="textPrimary" style={{ margin: '15px 0' }}>
          Internal Point of Contact
        </Typography>
        <Grid
          container
          xs={12}
          className={classnames(classes.zeroPaddingTop, classes.fullWidth)}
        >
          <div className={classnames(classes.flexColumn, classes.paddingBottom, classes.fullWidth)}>
            <div className={classnames(classes.flexBox, classes.fullWidth, classes.pr3, classes.paddingBottom)}>
              <DwlContactAdder
                options={availableUsers}
                onSelect={handleSelectContact}
              />
            </div>
            {values.dwlVerificationContacts
              ?.map(userId => dwlLocationUsers.find((u) => userId === u._id))
              .filter(u => !!u)
              .map((user, i) => {
                return (
                  <Grid key={user._id} container item xs={12} spacing={1} style={{ position: 'relative' }}>
                    <Grid item xs={6}>
                      <Typography variant="body1" color="textSecondary" style={{ margin: 0 }}>
                        Name:
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1" color="textSecondary" style={{ margin: 0 }}>
                        Email:
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        value={user.profile.fullName || user.username}
                        // label={user.profile.fullName || user.username}
                        disabled
                        fullWidth
                        variant="outlined"
                        className={classnames(classes.textField, classes.customSelect)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        value={user.profile.email}
                        // label={user.profile.email}
                        disabled
                        fullWidth
                        variant="outlined"
                        className={classnames(classes.textField, classes.customSelect)}
                      />
                    </Grid>
                      <div
                        className={classes.delCustomSelectIcon}
                        onClick={() => handleDeleteContact(user._id)}
                        aria-label="Delete"
                      >
                        <CloseIcon />
                      </div>
                  </Grid>
                );
              })
            }
            <div className={classnames(classes.flexColumn, classes.fullWidth)}>
            </div>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(DwlContacts);